export default __webpack_public_path__ + "static/media/kep2.a4520873.jpg";